export const config = {
  BASE_URL: "https://bol.dltc.spbu.ru",
  BASE_URL_PROXY: "/",
  BASE_URL_CERT: "https://bol.dltc.spbu.ru/certs",
  BASE_URL_API: "https://bol.dltc.spbu.ru",
  WEB_3_KEY_FROM: "0x2e68e3fbc2caadebefb7300c41297935955bbe4f"
};
//--Если меняется URL, его так же необходимо поменять в package.json, свойство 'proxy'
